module.exports = __webpack_public_path__ + "assets/images/scrolly-network/desktop.svg?v=00843abc";